import { render } from "./QueueDetailPage.vue?vue&type=template&id=1ceec51e&ts=true"
import script from "./QueueDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueueDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/queue/QueueDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ceec51e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ceec51e', __exports__)) {
    api.reload('1ceec51e', __exports__)
  }
  
  module.hot.accept("./QueueDetailPage.vue?vue&type=template&id=1ceec51e&ts=true", () => {
    api.rerender('1ceec51e', render)
  })

}


export default __exports__